import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { TextField } from '@material-ui/core';
import {
  Grid,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  CircularProgress,
  IconButton,
  AppBar,
  Tabs,
  Tab,
} from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import RemoveRedEyeIcon from '@material-ui/icons/RemoveRedEye';
import ArchiveIcon from '@material-ui/icons/Archive';
import UnarchiveIcon from '@material-ui/icons/Unarchive';

import TabPanel from '../../components/TabPanel';
import Button from '../../components/Button';
import Avatar from '../../components/Avatar';
import ConsultNoteEditModal from '../../components/ConsultNoteEditModal';
import ProviderSearchBar from '../../components/ProviderSearchBar';
import PatientSearchBar from '../../components/PatientSearchBar';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import {
  fetchConsultNotesPage,
  createConsultNote,
  archiveConsultNote,
  unarchiveConsultNote,
  updateToggle,
  fetchPatientById,
} from '../../services/api';
import * as authApi from '../../services/api/auth';
import ConsultNotesViewModal from './ConsultNotesViewModal';
import './style.css';

const ARCHIVED_BY_ID_TAB = 1;
const PAGE_LIMIT = 10;

function ProviderAdminConsultNotes(props) {
  const { classes } = props;
  const { enqueueSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [consultNotes, setConsultNotes] = useState([]);
  const [tabPosition, setTabPosition] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [openConsultNoteEditModal, setOpenConsultNoteEditModal] = useState(
    false
  );
  const [noteUnderEdit, setNoteUnderEdit] = useState({});
  const [viewOnly, setViewOnly] = useState(true);
  const [providersSearchId, setProvidersSearchId] = useState(null);
  const [patientsSearchId, setPatientsSearchId] = useState(null);
  const [requestPatientView, setRequestPatientView] = useState(false);
  const [patientInfo, setPatientInfo] = useState({});
  const [patientId, setPatientId] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      const user = await authApi.fetchCurrentUser();
      setCurrentUser(user);
    })();
  }, []);

  useEffect(() => {
    if(!currentUser) return;
    (async () => {
      await getConsultNotes();
    })();
  }, [currentUser, pageIndex, tabPosition, providersSearchId, patientsSearchId]);

  const getConsultNotes = async () => {
    try {
      setIsLoading(true);
      const userId = currentUser.id;
      const providerID = currentUser.provider.id;
      const isAdmin = currentUser.admin;
      const notes = await fetchConsultNotesPage(
        tabPosition === ARCHIVED_BY_ID_TAB,
        PAGE_LIMIT,
        providersSearchId,
        patientsSearchId,
        pageIndex * 10,
        userId,
        providerID,
        isAdmin
      );
      setConsultNotes(notes);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to fetch notes, please try again.');
    }
  };

  const sendConsultNote = async noteParams => {
    try {
      await createConsultNote(noteParams);
      getConsultNotes();
      enqueueSnackbar('Successfully sent note!');
      setOpenConsultNoteEditModal(false);
    } catch (err) {
      enqueueSnackbar('Unable to send note. Please try again.');
    }
  };

  const updateConsultNote = async noteParams => {
    try {
      await updateToggle(noteParams);
      getConsultNotes();
      enqueueSnackbar('Successfully update note!');
      setOpenConsultNoteEditModal(false);
    } catch (err) {
      enqueueSnackbar('Unable to send note. Please try again.');
    }
  };

  const handleTabPositionChange = (event, newTabPosition) => {
    setPageIndex(0);
    setTabPosition(newTabPosition);
  };

  const name = { nam: currentUser && currentUser.name };
  const userId = String(name.nam);

  const onViewConsultNote = note => {
    setNoteUnderEdit(note);
    setOpenConsultNoteEditModal(true);
    setViewOnly(true);
  };

  const onArchiveConsultNote = async (note, currentUser) => {
    try {
      await archiveConsultNote(currentUser, note);
      enqueueSnackbar('Successfully archived note!');
      getConsultNotes();
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to archive note, please try again.');
    }
  };

  const onUnarchiveConsultNote = async (note, currentUser) => {
    try {
      await unarchiveConsultNote(note,currentUser);
      enqueueSnackbar('Successfully unarchived note!');
      getConsultNotes();
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to unarchive note, please try again.');
    }
  };

  const onSendAConsultNote = () => {
    setViewOnly(false);
    setOpenConsultNoteEditModal(true);
  };

  const onCloseModal = () => {
    setNoteUnderEdit({});
    setOpenConsultNoteEditModal(false);
  };

  const onPageForward = () => {
    //this won't cover the case where the total num of consult notes % PAGE_LIMIT = 0. But it's a quick fix for now.
    if (consultNotes.length < PAGE_LIMIT) {
      enqueueSnackbar('You are on the last page');
    } else {
      setPageIndex(pageIndex + 1);
    }
  };

  const onPageBack = () => {
    if (pageIndex === 0) {
      enqueueSnackbar('You are on the first page');
    } else {
      setPageIndex(pageIndex - 1);
    }
  };

  const handleProviderToSearch = provider => {
    setPageIndex(0);
    setProvidersSearchId(provider && provider.id);
  };

  const handlePatientToSearch = patient => {
    setPageIndex(0);
    setPatientsSearchId(patient && patient.id);
  };

  const onRequestPatientView = notes => {
    // console.log('notes----', notes && notes.patientId);
    // const patientInfo = await fetchPatientById(notes.patientId);
    // console.log('patientinfo------', patientInfo);
    setPatientId(notes.patientId);
    // setPatientInfo(patientInfo);
    setRequestPatientView(true);
    setLoading(true);
  };

  const patientInfoPopup = () => {
    setRequestPatientView(false);
  };

  return (
    <Grid container classes={{ container: classes.container }}>
      <Grid item xs={12} classes={{ item: classes.header }}>
        <div className="DOCmsgHeader">
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item xs={6}>
            <Typography variant="h2" className={classes.headerText}>
              Doc to Doc Messages
            </Typography>
          </Grid>

          <Grid item xs={6} classes={{ item: classes.actions }}>
            <Button
              color="primary"
              variant="contained"
              onClick={onSendAConsultNote}
            >
              Message a doc
            </Button>
          </Grid>
        </Grid>
        </div>
      </Grid>

      <AppBar
        position="static"
        color="default"
        classes={{ root: classes.appBar }}
      >
        <Tabs value={tabPosition} onChange={handleTabPositionChange}>
          <Tab label="Open" />
          <Tab label="Archived" />
        </Tabs>
      </AppBar>

      <TabPanel>
        <div style={{overflow:"scroll"}}>
        <Grid container item xs={12} spacing={4}>
          {currentUser && currentUser.admin ? (
            <>
              <Grid item xs={6}>
                <ProviderSearchBar
                  clearable={true}
                  label=""
                  placeholder="Filter by provider"
                  onSelect={handleProviderToSearch}
                />
              </Grid>
              <Grid item xs={6}>
                <PatientSearchBar
                  clearable={true}
                  onSelect={handlePatientToSearch}
                  placeholder="Filter by patient"
                  label=""
                />
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={6}>
                <PatientSearchBar
                  clearable={true}
                  onSelect={handlePatientToSearch}
                  placeholder="Filter by patient"
                  label=""
                  className="fullWidthSearch"
                />
              </Grid>
            </>
          )}
          {isLoading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Patient</TableCell>
                    <TableCell>From (Provider)</TableCell>
                    <TableCell>To (Provider)</TableCell>
                    <TableCell>Received On</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentUser && currentUser.admin ? (
                    <>
                      {' '}
                      {consultNotes
                        // .sort((n1, n2) => {
                        //   return moment(n1.createdAt).isAfter(n2.createdAt)
                        //     ? -1
                        //     : 1;
                        // })
                        .map(note => (
                          <TableRow key={note.id}>
                            <TableCell width="250">
                              {note.patientName}
                            </TableCell>
                            <TableCell width="300">
                              <Grid container alignItems="center">
                                <Avatar
                                  providerId={note.fromProviderId}
                                  customStyles={{
                                    height: '35px',
                                    width: '35px',
                                  }}
                                />
                                <Grid item xs={6}>
                                  {note.fromProviderName}
                                </Grid>
                              </Grid>
                            </TableCell>
                            <TableCell width="300">
                              <Grid container alignItems="center">
                                <Avatar
                                  providerId={note.toProviderId}
                                  customStyles={{
                                    height: '35px',
                                    width: '35px',
                                  }}
                                />
                                <Grid item xs={6}>
                                  {note.toProviderName}
                                </Grid>
                              </Grid>
                            </TableCell>
                            <TableCell width="200">
                              {moment(note.createdAt).format(
                                'MM/DD/YYYY hh:mma'
                              )}
                            </TableCell>
                            <TableCell>
                              <IconButton
                                onClick={() => onRequestPatientView(note)}
                                title={"Message" }
                              >
                                <RemoveRedEyeIcon />
                              </IconButton>

                              {!note.archived && tabPosition === 0 ? (
                                <IconButton
                                  onClick={() =>
                                    onArchiveConsultNote(note, currentUser)
                                  }
                                  title={"Archive" }
                                >
                                  <ArchiveIcon />
                                </IconButton>
                              ) : (
                                <IconButton
                                  onClick={() => onUnarchiveConsultNote(note, currentUser)}
                                  title={"UnArchive" }
                                >
                                  <UnarchiveIcon />
                                </IconButton>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                    </>
                  ) : (
                    <>
                      {' '}
                      {consultNotes
                        // .filter(
                        //   note =>
                        //     note.fromProviderName === userId ||
                        //     note.toProviderName === userId
                        // )
                        // .sort((n1, n2) => {
                        //   return moment(n1.createdAt).isAfter(n2.createdAt)
                        //     ? -1
                        //     : 1;
                        // })
                        .map(note => (
                          <TableRow key={note.id}>
                            <TableCell width="250">
                              {note.patientName}
                            </TableCell>
                            <TableCell width="300">
                              <Grid container alignItems="center">
                                <Avatar
                                  providerId={note.fromProviderId}
                                  customStyles={{
                                    height: '35px',
                                    width: '35px',
                                  }}
                                />
                                <div className="docToDocName">
                                <Grid item xs={6}>
                                  {note.fromProviderName}
                                </Grid>
                                </div>
                              </Grid>
                            </TableCell>
                            <TableCell width="300">
                              <Grid container alignItems="center">
                                <Avatar
                                  providerId={note.toProviderId}
                                  customStyles={{
                                    height: '35px',
                                    width: '35px',
                                  }}
                                />
                                <div className="docToDocName">
                                <Grid item xs={6}>
                                  {note.toProviderName}
                                </Grid>
                                </div>
                              </Grid>
                            </TableCell>
                            <TableCell width="200">
                              {moment(note.createdAt).format(
                                'MM/DD/YYYY hh:mma'
                              )}
                            </TableCell>
                            <TableCell>
                              <IconButton
                                onClick={() => onViewConsultNote(note)}
                                title={"Message" }
                              >
                                <RemoveRedEyeIcon />
                              </IconButton>

                              <IconButton
                                onClick={() => onRequestPatientView(note)}
                                title={"Patient Details" }
                              >
                                <PeopleAltIcon />
                              </IconButton>

                              {!note.archived && tabPosition === 0 ? (
                                <IconButton
                                  onClick={() =>
                                    onArchiveConsultNote(note, currentUser)
                                  }
                                  title={"Archive" }
                                >
                                  <ArchiveIcon />
                                </IconButton>
                              ) : (
                                <IconButton
                                  onClick={() => onUnarchiveConsultNote(note,currentUser)}
                                  title={"UnArchive" }
                                >
                                  <UnarchiveIcon />
                                </IconButton>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                    </>
                  )}
                </TableBody>
              </Table>
              
            </>
          )}
        </Grid>
        </div>
        <div className={classes.pageTurners}>
                <IconButton disabled={pageIndex === 0}>
                  <ArrowBackIosIcon
                    style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
                    color="primary"
                    variant="contained"
                    onClick={onPageBack}
                  />
                </IconButton>
                <IconButton>{pageIndex+1}</IconButton>
                <IconButton disabled={consultNotes.length < PAGE_LIMIT}>
                  <ArrowForwardIosIcon
                    style={{
                      opacity: consultNotes.length < PAGE_LIMIT ? '0.5' : '1.0',
                    }}
                    color="primary"
                    variant="contained"
                    onClick={onPageForward}
                  />
                </IconButton>
              </div>
        {requestPatientView && (
          <ConsultNotesViewModal
            open={requestPatientView}
            onClose={patientInfoPopup}
            patientInfo={patientInfo}
            patientId={patientId}
            setLoading={setLoading}
            loading={loading}
          />
        )}
      </TabPanel>
      {openConsultNoteEditModal && (
        <ConsultNoteEditModal
          viewOnly={viewOnly}
          open={openConsultNoteEditModal}
          onClose={onCloseModal}
          note={noteUnderEdit}
          save={sendConsultNote}
          update={updateConsultNote}
          userId={userId}
        />
      )}
    </Grid>
  );
}

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    padding: '3em',
  },
  appBar: {
    zIndex: 10,
  },
  header: {
    paddingBottom: '3em',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
  headerText: {
    fontWeight: 'normal',
    fontSize: '1.8em',
    lineHeight: '1.2em',
    color: '#1C1C1C',
  },
  actions: {
    textAlign: 'right',
  },
  pageTurners: {
    width: '100%',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'center',
  },
});

export default withStyles(styles)(ProviderAdminConsultNotes);
